<div
  class="flex flex-col gap-2 mb-round p-6 bg-mbaza-gray-very-light"
  *transloco="let t"
>
  <span class="font-extrabold">{{ t("reporterReview") }}</span>
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row gap-2 items-baseline">
      <span class="font-bold inline-block align-baseline">{{ review?.rating }}/5</span>
      <nz-rate [ngModel]="review?.rating" nzDisabled></nz-rate>
    </div>
    <span class="text-mbaza-gray text-xs font-light"
      >{{ review?.createdAt | date : "dd MMM yyyy - HH:mm" }}</span
    >
  </div>
  <span> {{ review?.comment }} </span>
</div>
